<script lang="ts" setup>
import { useCartStore } from '~/store/cart'

const cartStore = useCartStore()
</script>

<template>
  <div v-if="cartStore.notifications.length">
    <Notification
      v-for="(x, i) in cartStore.notifications"
      :key="i"
      class="mb-6"
      :is-small="x.isSmall"
      :status="x.status"
    >
      <HtmlArea v-if="x.html" :plain-html="x.html" />
      <pre v-else-if="x.text" class="pre-wrap">{{ x.text }}</pre>
    </Notification>
  </div>
</template>
